DJ.addBehavior('timeline', '.timeline', {
  attach: function (context, settings, behavior) {
    if (jQuery(".timeline__content").length > 0) {

      jQuery('.timeline__outer').scroll(function () {
        jQuery(this).css({'--scrollLeft': jQuery(this).scrollLeft() + 'px'})
      });

      jQuery('.timeline-wrapper .timeline__item [data-text-slpitted]').each(function () {
        var item = jQuery(this);
        var title = item.parents('.tl-card__content').find('.tl-card__title');
        if (title.text().length > 100) {
          item.removeAttr('data-text-slpitted');
          title.addClass('long-text')
        }
      })

      var items = jQuery(".timeline__item").length;
      var width = 0;
      jQuery(".timeline__item").each(function () {
        var $this = jQuery(this);
        width += $this.outerWidth(true);
      });
      jQuery(".timeline__content").width(width);
      jQuery(".timeline__content").addClass("timeline--init");
      jQuery(".timeline__content").width(width);
      var outer = document.querySelector(".timeline__outer")
      var o = false
      outer.addEventListener("mousedown", (e) => {
        o = !0;
        outer.classList.add("active");
        a = e.pageX - outer.offsetLeft;
        r = outer.scrollLeft;
      })
      outer.addEventListener("mouseleave", () => {
        o = !1;
        outer.classList.remove("active");
      })
      outer.addEventListener("mouseup", () => {
        o = !1;
        outer.classList.remove("active");
      })
      outer.addEventListener("mousemove", (e) => {
        if (o) {
          e.preventDefault();
          e = e.pageX - outer.offsetLeft - a;
          outer.scrollLeft = r - e
        }
      })
    }
  },

  detach: function (context, settings) {
  }
});
